const api_key = process.env.API_KEY;

export interface SearchForGifs {
  searchTerm: string;
  limit?: number;
  rating?: "G" | "PG" | "PG-13" | "R";
  offset?: number;
  abortController?: AbortController;
}

const searchForGifsUrl = `https://api.giphy.com/v1/gifs/search?api_key=${api_key}`;

async function searchForGifs({
  searchTerm,
  limit = 25,
  rating = "G",
  offset = 0,
  abortController = new AbortController(),
}: SearchForGifs) {
  const params = objectToParams({ q: searchTerm, limit, rating, offset });

  const response = {
    data: [
      {
        type: "gif",
        id: "eYilisUwipOEM",
        url:
          "https://giphy.com/gifs/barkpost-barkpost-happy-wednesday-working-like-a-dog-eYilisUwipOEM",
        slug:
          "barkpost-barkpost-happy-wednesday-working-like-a-dog-eYilisUwipOEM",
        bitly_gif_url: "https://gph.is/NYMue5",
        bitly_url: "https://gph.is/NYMue5",
        embed_url: "https://giphy.com/embed/eYilisUwipOEM",
        username: "barkpost",
        source: "",
        title: "Dogs Laughing GIF by The BarkPost",
        rating: "g",
        content_url: "",
        source_tld: "",
        source_post_url: "",
        is_sticker: 0,
        import_datetime: "2013-07-24 15:18:21",
        trending_datetime: "2020-05-02 10:45:01",
        images: {
          downsized_large: {
            height: "362",
            size: "77604",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "500",
          },
          fixed_height_small_still: {
            height: "100",
            size: "8636",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "138",
          },
          original: {
            frames: "4",
            hash: "7a30e3bfee243569eee09bc711e81505",
            height: "362",
            mp4:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "88797",
            size: "77604",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "76908",
            width: "500",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "38757",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media3.giphy.com/media/eYilisUwipOEM/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "17192",
            width: "276",
          },
          downsized_still: {
            height: "362",
            size: "77604",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "500",
          },
          fixed_height_still: {
            height: "200",
            size: "31347",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "276",
          },
          downsized_medium: {
            height: "362",
            size: "77604",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "500",
          },
          downsized: {
            height: "362",
            size: "77604",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "500",
          },
          preview_webp: {
            height: "276",
            size: "29256",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "382",
          },
          original_mp4: {
            height: "346",
            mp4:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "88797",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media3.giphy.com/media/eYilisUwipOEM/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "5116",
            size: "10194",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media3.giphy.com/media/eYilisUwipOEM/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "3928",
            width: "138",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media3.giphy.com/media/eYilisUwipOEM/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "18534",
            size: "38757",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media3.giphy.com/media/eYilisUwipOEM/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "14128",
            width: "276",
          },
          downsized_small: {
            height: "362",
            mp4:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "116464",
            width: "500",
          },
          preview: {
            height: "236",
            mp4:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "15696",
            width: "326",
          },
          fixed_width_downsampled: {
            height: "145",
            size: "19038",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media3.giphy.com/media/eYilisUwipOEM/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "9650",
            width: "200",
          },
          fixed_width_small_still: {
            height: "73",
            size: "4744",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "73",
            mp4:
              "https://media3.giphy.com/media/eYilisUwipOEM/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "3713",
            size: "6190",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media3.giphy.com/media/eYilisUwipOEM/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "2596",
            width: "100",
          },
          original_still: {
            height: "362",
            size: "65845",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "500",
          },
          fixed_width_still: {
            height: "145",
            size: "14820",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "5158671",
          },
          fixed_width: {
            height: "145",
            mp4:
              "https://media3.giphy.com/media/eYilisUwipOEM/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "8678",
            size: "19038",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media3.giphy.com/media/eYilisUwipOEM/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "6662",
            width: "200",
          },
          preview_gif: {
            height: "171",
            size: "47301",
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "236",
          },
          "480w_still": {
            url:
              "https://media3.giphy.com/media/eYilisUwipOEM/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "348",
          },
        },
        user: {
          avatar_url:
            "https://media0.giphy.com/avatars/barkpost/YNdJTWjWJRUa.gif",
          banner_image:
            "https://media0.giphy.com/avatars/BarkPost/TiADGxEBqQWq.gif",
          banner_url:
            "https://media0.giphy.com/avatars/BarkPost/TiADGxEBqQWq.gif",
          profile_url: "https://giphy.com/barkpost/",
          username: "barkpost",
          display_name: "The BarkPost",
          is_verified: true,
        },
        analytics_response_payload:
          "e=Z2lmX2lkPWVZaWxpc1V3aXBPRU0mZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=eYilisUwipOEM&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=eYilisUwipOEM&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=eYilisUwipOEM&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "cLcxtL1z8t8oo",
        url: "https://giphy.com/gifs/jump-training-rope-cLcxtL1z8t8oo",
        slug: "jump-training-rope-cLcxtL1z8t8oo",
        bitly_gif_url: "https://gph.is/1TEeoGs",
        bitly_url: "https://gph.is/1TEeoGs",
        embed_url: "https://giphy.com/embed/cLcxtL1z8t8oo",
        username: "",
        source:
          "https://www.reddit.com/r/gifs/comments/4itv7w/dogs_rope_jump_training_in_asia/",
        title: "dogs jumprope GIF",
        rating: "g",
        content_url: "",
        source_tld: "www.reddit.com",
        source_post_url:
          "https://www.reddit.com/r/gifs/comments/4itv7w/dogs_rope_jump_training_in_asia/",
        is_sticker: 0,
        import_datetime: "2016-05-11 07:50:20",
        trending_datetime: "2016-10-18 00:15:00",
        images: {
          downsized_large: {
            height: "352",
            size: "3575754",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "300",
          },
          fixed_height_small_still: {
            height: "100",
            size: "5747",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "85",
          },
          original: {
            frames: "58",
            hash: "0a6cb015b626fdf044a69089b547c64c",
            height: "352",
            mp4:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1968715",
            size: "3575754",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "1207266",
            width: "300",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "112472",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "64758",
            width: "170",
          },
          downsized_still: {
            height: "281",
            size: "26226",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "240",
          },
          fixed_height_still: {
            height: "200",
            size: "16606",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "170",
          },
          downsized_medium: {
            height: "352",
            size: "3575754",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "300",
          },
          downsized: {
            height: "281",
            size: "1475702",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "240",
          },
          preview_webp: {
            height: "106",
            size: "32956",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "90",
          },
          original_mp4: {
            height: "562",
            mp4:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1968715",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "90135",
            size: "292401",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "134976",
            width: "85",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "245562",
            size: "923165",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "377422",
            width: "170",
          },
          downsized_small: {
            height: "152",
            mp4:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "90680",
            width: "129",
          },
          preview: {
            height: "156",
            mp4:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "44460",
            width: "132",
          },
          fixed_width_downsampled: {
            height: "235",
            size: "147663",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "84616",
            width: "200",
          },
          fixed_width_small_still: {
            height: "118",
            size: "7841",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "118",
            mp4:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "48616",
            size: "418819",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "172170",
            width: "100",
          },
          original_still: {
            height: "352",
            size: "62137",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "300",
          },
          fixed_width_still: {
            height: "235",
            size: "21560",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "5499938",
          },
          fixed_width: {
            height: "235",
            mp4:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "315433",
            size: "1213931",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "483128",
            width: "200",
          },
          preview_gif: {
            height: "73",
            size: "47597",
            url:
              "https://media0.giphy.com/media/cLcxtL1z8t8oo/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "62",
          },
          "480w_still": {
            url:
              "https://media1.giphy.com/media/cLcxtL1z8t8oo/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "563",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPWNMY3h0TDF6OHQ4b28mZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=cLcxtL1z8t8oo&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=cLcxtL1z8t8oo&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=cLcxtL1z8t8oo&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "fItgT774J3nWw",
        url: "https://giphy.com/gifs/yoda-count-dooku-fItgT774J3nWw",
        slug: "yoda-count-dooku-fItgT774J3nWw",
        bitly_gif_url: "https://gph.is/2gb8H6T",
        bitly_url: "https://gph.is/2gb8H6T",
        embed_url: "https://giphy.com/embed/fItgT774J3nWw",
        username: "",
        source:
          "https://www.reddit.com/r/StarWars/comments/5h0uzp/and_you_thought_yoda_fighting_count_dooku_was/",
        title: "star wars dogs GIF",
        rating: "g",
        content_url: "",
        source_tld: "www.reddit.com",
        source_post_url:
          "https://www.reddit.com/r/StarWars/comments/5h0uzp/and_you_thought_yoda_fighting_count_dooku_was/",
        is_sticker: 0,
        import_datetime: "2016-12-07 16:40:09",
        trending_datetime: "2019-07-07 17:45:02",
        images: {
          downsized_large: {
            height: "400",
            size: "7300254",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "400",
          },
          fixed_height_small_still: {
            height: "100",
            size: "10112",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "100",
          },
          original: {
            frames: "76",
            hash: "6e2f500e44b8fd42e9cf0a11a0569d37",
            height: "400",
            mp4:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "413659",
            size: "7300254",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "1573492",
            width: "400",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "186861",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media0.giphy.com/media/fItgT774J3nWw/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "48766",
            width: "200",
          },
          downsized_still: {
            height: "250",
            size: "49934",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "250",
          },
          fixed_height_still: {
            height: "200",
            size: "31781",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "200",
          },
          downsized_medium: {
            height: "320",
            size: "4846944",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy-downsized-medium.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-medium.gif",
            width: "320",
          },
          downsized: {
            height: "250",
            size: "1292803",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "250",
          },
          preview_webp: {
            height: "141",
            size: "49320",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "141",
          },
          original_mp4: {
            height: "480",
            mp4:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "413659",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media0.giphy.com/media/fItgT774J3nWw/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "49318",
            size: "603352",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media0.giphy.com/media/fItgT774J3nWw/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "230428",
            width: "100",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media0.giphy.com/media/fItgT774J3nWw/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "121988",
            size: "2071367",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media0.giphy.com/media/fItgT774J3nWw/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "603930",
            width: "200",
          },
          downsized_small: {
            height: "240",
            mp4:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "150756",
            width: "240",
          },
          preview: {
            height: "248",
            mp4:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "38523",
            width: "248",
          },
          fixed_width_downsampled: {
            height: "200",
            size: "186861",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media0.giphy.com/media/fItgT774J3nWw/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "48766",
            width: "200",
          },
          fixed_width_small_still: {
            height: "100",
            size: "10112",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "100",
            mp4:
              "https://media0.giphy.com/media/fItgT774J3nWw/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "49318",
            size: "603352",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media0.giphy.com/media/fItgT774J3nWw/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "230428",
            width: "100",
          },
          original_still: {
            height: "400",
            size: "105197",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "400",
          },
          fixed_width_still: {
            height: "200",
            size: "31781",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "1256971",
          },
          fixed_width: {
            height: "200",
            mp4:
              "https://media0.giphy.com/media/fItgT774J3nWw/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "121988",
            size: "2071367",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media0.giphy.com/media/fItgT774J3nWw/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "603930",
            width: "200",
          },
          preview_gif: {
            height: "91",
            size: "49482",
            url:
              "https://media0.giphy.com/media/fItgT774J3nWw/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "91",
          },
          "480w_still": {
            url:
              "https://media3.giphy.com/media/fItgT774J3nWw/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "480",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPWZJdGdUNzc0SjNuV3cmZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=fItgT774J3nWw&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=fItgT774J3nWw&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=fItgT774J3nWw&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "mokQK7oyiR8Sk",
        url: "https://giphy.com/gifs/mokQK7oyiR8Sk",
        slug: "mokQK7oyiR8Sk",
        bitly_gif_url: "https://gph.is/29jbBXC",
        bitly_url: "https://gph.is/29jbBXC",
        embed_url: "https://giphy.com/embed/mokQK7oyiR8Sk",
        username: "",
        source: "https://imgur.com/gallery/7LKQLPM",
        title: "dogs GIF",
        rating: "g",
        content_url: "",
        source_tld: "imgur.com",
        source_post_url: "https://imgur.com/gallery/7LKQLPM",
        is_sticker: 0,
        import_datetime: "2016-07-02 07:38:44",
        trending_datetime: "2018-04-09 17:00:01",
        images: {
          downsized_large: {
            height: "275",
            size: "2054571",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "355",
          },
          fixed_height_small_still: {
            height: "100",
            size: "10908",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "129",
          },
          original: {
            frames: "40",
            hash: "421883ebef2ea2d3b0025370ddfe9d31",
            height: "275",
            mp4:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "841397",
            size: "2054571",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "776918",
            width: "355",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "179873",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "98888",
            width: "258",
          },
          downsized_still: {
            height: "275",
            size: "34219",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "355",
          },
          fixed_height_still: {
            height: "200",
            size: "28341",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "258",
          },
          downsized_medium: {
            height: "275",
            size: "2054571",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "355",
          },
          downsized: {
            height: "275",
            size: "1310473",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "355",
          },
          preview_webp: {
            height: "86",
            size: "38954",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "112",
          },
          original_mp4: {
            height: "370",
            mp4:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "841397",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "80041",
            size: "378681",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "146090",
            width: "129",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "226674",
            size: "1079367",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "414248",
            width: "258",
          },
          downsized_small: {
            height: "168",
            mp4:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "91923",
            width: "217",
          },
          preview: {
            height: "116",
            mp4:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "41497",
            width: "149",
          },
          fixed_width_downsampled: {
            height: "155",
            size: "119453",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "65598",
            width: "200",
          },
          fixed_width_small_still: {
            height: "78",
            size: "6610",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "78",
            mp4:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "47789",
            size: "221240",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "98776",
            width: "100",
          },
          original_still: {
            height: "275",
            size: "53740",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "355",
          },
          fixed_width_still: {
            height: "155",
            size: "18543",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "4588640",
          },
          fixed_width: {
            height: "155",
            mp4:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "151682",
            size: "695136",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "279842",
            width: "200",
          },
          preview_gif: {
            height: "57",
            size: "49222",
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "74",
          },
          "480w_still": {
            url:
              "https://media1.giphy.com/media/mokQK7oyiR8Sk/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "372",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPW1va1FLN295aVI4U2smZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=mokQK7oyiR8Sk&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=mokQK7oyiR8Sk&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=mokQK7oyiR8Sk&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "d3Fym9OQ08o6agYE",
        url:
          "https://giphy.com/gifs/natgeowild-funny-nat-geo-wild-barkfest-d3Fym9OQ08o6agYE",
        slug: "natgeowild-funny-nat-geo-wild-barkfest-d3Fym9OQ08o6agYE",
        bitly_gif_url: "https://gph.is/23pdvfN",
        bitly_url: "https://gph.is/23pdvfN",
        embed_url: "https://giphy.com/embed/d3Fym9OQ08o6agYE",
        username: "natgeowild",
        source: "https://channel.nationalgeographic.com/wild/",
        title: "windy hair GIF by Nat Geo Wild",
        rating: "g",
        content_url: "",
        source_tld: "channel.nationalgeographic.com",
        source_post_url: "https://channel.nationalgeographic.com/wild/",
        is_sticker: 0,
        import_datetime: "2016-04-11 17:13:57",
        trending_datetime: "2020-01-08 06:00:09",
        images: {
          downsized_large: {
            height: "270",
            size: "3366960",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          fixed_height_small_still: {
            height: "100",
            size: "9374",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "178",
          },
          original: {
            frames: "83",
            hash: "1d141eba37649ed108756d68b7e7a759",
            height: "270",
            mp4:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "676519",
            size: "3366960",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "1091366",
            width: "480",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "142504",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "90890",
            width: "356",
          },
          downsized_still: {
            height: "270",
            size: "34430",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "480",
          },
          preview_webp: {
            height: "144",
            size: "46688",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "256",
          },
          fixed_height_still: {
            height: "200",
            size: "22453",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "356",
          },
          downsized_medium: {
            height: "270",
            size: "3366960",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          downsized: {
            height: "270",
            size: "1562927",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "480",
          },
          original_mp4: {
            height: "270",
            mp4:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "676519",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "105580",
            size: "610665",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "349712",
            width: "178",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "339904",
            size: "1762897",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "1057828",
            width: "356",
          },
          fixed_width_small: {
            height: "57",
            mp4:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "43908",
            size: "248119",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "140172",
            width: "100",
          },
          downsized_small: {
            height: "122",
            mp4:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "75394",
            width: "216",
          },
          preview: {
            height: "190",
            mp4:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "35782",
            width: "337",
          },
          fixed_width_downsampled: {
            height: "113",
            size: "56312",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "34008",
            width: "200",
          },
          fixed_width_small_still: {
            height: "57",
            size: "3775",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          "480w_still": {
            height: "270",
            size: "13467",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
          },
          original_still: {
            height: "270",
            size: "63519",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "480",
          },
          fixed_width_still: {
            height: "113",
            size: "12266",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "1541384",
          },
          fixed_width: {
            height: "113",
            mp4:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "119093",
            size: "736526",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "419756",
            width: "200",
          },
          preview_gif: {
            height: "85",
            size: "49029",
            url:
              "https://media2.giphy.com/media/d3Fym9OQ08o6agYE/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "151",
          },
        },
        user: {
          avatar_url:
            "https://media3.giphy.com/avatars/natgeowild/zBojD0lYteHi.jpg",
          banner_image:
            "https://media3.giphy.com/headers/natgeowild/UplNMTnbMAkp.jpg",
          banner_url:
            "https://media3.giphy.com/headers/natgeowild/UplNMTnbMAkp.jpg",
          profile_url: "https://giphy.com/natgeowild/",
          username: "natgeowild",
          display_name: "Nat Geo Wild",
          is_verified: true,
        },
        analytics_response_payload:
          "e=Z2lmX2lkPWQzRnltOU9RMDhvNmFnWUUmZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=d3Fym9OQ08o6agYE&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=d3Fym9OQ08o6agYE&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=d3Fym9OQ08o6agYE&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "JTaHahqEVizjwKuc7e",
        url:
          "https://giphy.com/gifs/TikTokItalia-divertente-animali-carini-JTaHahqEVizjwKuc7e",
        slug: "TikTokItalia-divertente-animali-carini-JTaHahqEVizjwKuc7e",
        bitly_gif_url: "https://gph.is/g/amXJjkB",
        bitly_url: "https://gph.is/g/amXJjkB",
        embed_url: "https://giphy.com/embed/JTaHahqEVizjwKuc7e",
        username: "TikTokItalia",
        source: "https://www.tiktok.com/it/",
        title: "Dog Love GIF by TikTok Italia",
        rating: "g",
        content_url: "",
        source_tld: "www.tiktok.com",
        source_post_url: "https://www.tiktok.com/it/",
        is_sticker: 0,
        import_datetime: "2020-03-20 07:51:43",
        trending_datetime: "2020-05-09 19:15:04",
        images: {
          downsized_large: {
            height: "500",
            size: "5062064",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy-downsized-large.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-large.gif",
            width: "500",
          },
          fixed_height_small_still: {
            height: "100",
            size: "6734",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "100",
          },
          original: {
            frames: "56",
            hash: "c26b1e902f5ffd93b6659c5cb158a9e1",
            height: "500",
            mp4:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1955189",
            size: "8086907",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "3213088",
            width: "500",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "126116",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "74210",
            width: "200",
          },
          downsized_still: {
            height: "250",
            size: "24745",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "250",
          },
          fixed_height_still: {
            height: "200",
            size: "19517",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "200",
          },
          downsized_medium: {
            height: "400",
            size: "3598891",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy-downsized-medium.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-medium.gif",
            width: "400",
          },
          downsized: {
            height: "250",
            size: "1296165",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "250",
          },
          preview_webp: {
            height: "94",
            size: "29140",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "94",
          },
          original_mp4: {
            height: "480",
            mp4:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1955189",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "84501",
            size: "322521",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "180782",
            width: "100",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "288942",
            size: "1036604",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "535820",
            width: "200",
          },
          downsized_small: {
            height: "200",
            mp4:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "151329",
            width: "200",
          },
          preview: {
            height: "160",
            mp4:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "43458",
            width: "160",
          },
          fixed_width_downsampled: {
            height: "200",
            size: "126116",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "74210",
            width: "200",
          },
          fixed_width_small_still: {
            height: "100",
            size: "6734",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "100",
            mp4:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "47489",
            size: "322521",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "180782",
            width: "100",
          },
          original_still: {
            height: "500",
            size: "176395",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "500",
          },
          fixed_width_still: {
            height: "200",
            size: "19517",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "4837855",
          },
          fixed_width: {
            height: "200",
            mp4:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "288942",
            size: "1036604",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "535820",
            width: "200",
          },
          preview_gif: {
            height: "69",
            size: "49805",
            url:
              "https://media1.giphy.com/media/JTaHahqEVizjwKuc7e/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "69",
          },
          "480w_still": {
            url:
              "https://media0.giphy.com/media/JTaHahqEVizjwKuc7e/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "480",
          },
        },
        user: {
          avatar_url:
            "https://media4.giphy.com/avatars/TikTokItalia/8ESFhrUvyZw8.png",
          banner_image: "",
          banner_url: "",
          profile_url: "https://giphy.com/TikTokItalia/",
          username: "TikTokItalia",
          display_name: "TikTok Italia",
          is_verified: true,
        },
        analytics_response_payload:
          "e=Z2lmX2lkPUpUYUhhaHFFVml6andLdWM3ZSZldmVudF90eXBlPUdJRl9TRUFSQ0gmY2lkPTA1ZTgzOWY0YzAwZTEzMzkyY2I1YzAwNDRkYjhhNmZjZjk5MWE0NGE1MzJjOTIzYw",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=JTaHahqEVizjwKuc7e&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=JTaHahqEVizjwKuc7e&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=JTaHahqEVizjwKuc7e&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "L0NBGdEtE8tUP6MVwH",
        url:
          "https://giphy.com/gifs/friends-forest-enjoying-L0NBGdEtE8tUP6MVwH",
        slug: "friends-forest-enjoying-L0NBGdEtE8tUP6MVwH",
        bitly_gif_url: "https://gph.is/2oWTlZV",
        bitly_url: "https://gph.is/2oWTlZV",
        embed_url: "https://giphy.com/embed/L0NBGdEtE8tUP6MVwH",
        username: "",
        source: "/r/gifs/comments/82kps4/adorable_friends_enjoying_the_forest/",
        title: "Friends Enjoying GIF",
        rating: "g",
        content_url: "",
        source_tld: "",
        source_post_url:
          "/r/gifs/comments/82kps4/adorable_friends_enjoying_the_forest/",
        is_sticker: 0,
        import_datetime: "2018-03-07 02:10:18",
        trending_datetime: "2020-02-25 11:30:05",
        images: {
          hd: {
            height: "910",
            mp4:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy-hd.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-hd.mp4",
            mp4_size: "32067449",
            width: "728",
          },
          downsized_large: {
            height: "375",
            size: "7130877",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy-downsized-large.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-large.gif",
            width: "300",
          },
          fixed_height_small_still: {
            height: "100",
            size: "8544",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "80",
          },
          original: {
            frames: "175",
            hash: "60b20bd459d3a19b7cf251c51f09cd6b",
            height: "480",
            mp4:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "6247889",
            size: "25172397",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "7846488",
            width: "384",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "144369",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "53716",
            width: "160",
          },
          downsized_still: {
            height: "192",
            size: "27891",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "153",
          },
          fixed_height_still: {
            height: "200",
            size: "28685",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "160",
          },
          downsized_medium: {
            height: "309",
            size: "4391406",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy-downsized-medium.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-medium.gif",
            width: "247",
          },
          downsized: {
            height: "192",
            size: "1286322",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "153",
          },
          preview_webp: {
            height: "120",
            size: "48742",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "96",
          },
          original_mp4: {
            height: "600",
            mp4:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "6247889",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "193286",
            size: "1110274",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "495936",
            width: "80",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "632896",
            size: "3988934",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "1554580",
            width: "160",
          },
          downsized_small: {
            height: "150",
            mp4:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "195378",
            width: "120",
          },
          preview: {
            height: "152",
            mp4:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "35982",
            width: "121",
          },
          fixed_width_downsampled: {
            height: "250",
            size: "220148",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "77640",
            width: "200",
          },
          fixed_width_small_still: {
            height: "125",
            size: "12476",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "125",
            mp4:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "39524",
            size: "1683880",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "733316",
            width: "100",
          },
          original_still: {
            height: "480",
            size: "170292",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "384",
          },
          fixed_width_still: {
            height: "250",
            size: "43435",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "6516103",
          },
          fixed_width: {
            height: "250",
            mp4:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "949401",
            size: "6129524",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "2267358",
            width: "200",
          },
          preview_gif: {
            height: "90",
            size: "47872",
            url:
              "https://media2.giphy.com/media/L0NBGdEtE8tUP6MVwH/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "72",
          },
          "480w_still": {
            url:
              "https://media1.giphy.com/media/L0NBGdEtE8tUP6MVwH/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "600",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPUwwTkJHZEV0RTh0VVA2TVZ3SCZldmVudF90eXBlPUdJRl9TRUFSQ0gmY2lkPTA1ZTgzOWY0YzAwZTEzMzkyY2I1YzAwNDRkYjhhNmZjZjk5MWE0NGE1MzJjOTIzYw",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=L0NBGdEtE8tUP6MVwH&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=L0NBGdEtE8tUP6MVwH&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=L0NBGdEtE8tUP6MVwH&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "KEh5kliRTSVJm",
        url: "https://giphy.com/gifs/cool-yeah-drive-KEh5kliRTSVJm",
        slug: "cool-yeah-drive-KEh5kliRTSVJm",
        bitly_gif_url: "https://gph.is/1whjIG0",
        bitly_url: "https://gph.is/1whjIG0",
        embed_url: "https://giphy.com/embed/KEh5kliRTSVJm",
        username: "",
        source: "https://cheezburger.com/8350409984",
        title: "dogs driving GIF",
        rating: "g",
        content_url: "",
        source_tld: "cheezburger.com",
        source_post_url: "https://cheezburger.com/8350409984",
        is_sticker: 0,
        import_datetime: "2014-10-19 11:16:51",
        trending_datetime: "2017-04-27 05:00:01",
        images: {
          downsized_large: {
            height: "360",
            size: "3443273",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "360",
          },
          fixed_height_small_still: {
            height: "100",
            size: "6673",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "100",
          },
          original: {
            frames: "46",
            hash: "ccaac3468bd44cced3a52996ae190960",
            height: "360",
            mp4:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1366191",
            size: "3443273",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "982036",
            width: "360",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "121811",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "63344",
            width: "200",
          },
          downsized_still: {
            height: "360",
            size: "36785",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "360",
          },
          fixed_height_still: {
            height: "200",
            size: "18301",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "200",
          },
          downsized_medium: {
            height: "360",
            size: "3443273",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "360",
          },
          downsized: {
            height: "360",
            size: "1669717",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "360",
          },
          preview_webp: {
            height: "128",
            size: "39096",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "128",
          },
          original_mp4: {
            height: "480",
            mp4:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1366191",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "76099",
            size: "255360",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "132066",
            width: "100",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "202321",
            size: "790219",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "296398",
            width: "200",
          },
          downsized_small: {
            height: "160",
            mp4:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "79877",
            width: "160",
          },
          preview: {
            height: "186",
            mp4:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "40459",
            width: "186",
          },
          fixed_width_downsampled: {
            height: "200",
            size: "121811",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "63344",
            width: "200",
          },
          fixed_width_small_still: {
            height: "100",
            size: "6673",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "100",
            mp4:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "47669",
            size: "255360",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "132066",
            width: "100",
          },
          original_still: {
            height: "360",
            size: "78220",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "360",
          },
          fixed_width_still: {
            height: "200",
            size: "18301",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "3516805",
          },
          fixed_width: {
            height: "200",
            mp4:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "202321",
            size: "790219",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "296398",
            width: "200",
          },
          preview_gif: {
            height: "68",
            size: "49661",
            url:
              "https://media0.giphy.com/media/KEh5kliRTSVJm/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "68",
          },
          "480w_still": {
            url:
              "https://media1.giphy.com/media/KEh5kliRTSVJm/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "480",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPUtFaDVrbGlSVFNWSm0mZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=KEh5kliRTSVJm&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=KEh5kliRTSVJm&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=KEh5kliRTSVJm&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "B2vBunhgt9Pc4",
        url: "https://giphy.com/gifs/dogs-think-turtles-B2vBunhgt9Pc4",
        slug: "dogs-think-turtles-B2vBunhgt9Pc4",
        bitly_gif_url: "https://gph.is/2gByngm",
        bitly_url: "https://gph.is/2gByngm",
        embed_url: "https://giphy.com/embed/B2vBunhgt9Pc4",
        username: "",
        source:
          "https://www.reddit.com/r/gifs/comments/5htyf4/if_you_think_dogs_and_turtles_cannot_play/",
        title: "dogs think GIF",
        rating: "g",
        content_url: "",
        source_tld: "www.reddit.com",
        source_post_url:
          "https://www.reddit.com/r/gifs/comments/5htyf4/if_you_think_dogs_and_turtles_cannot_play/",
        is_sticker: 0,
        import_datetime: "2016-12-12 02:09:09",
        trending_datetime: "2016-12-14 15:00:01",
        images: {
          downsized_large: {
            height: "400",
            size: "4227596",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "400",
          },
          fixed_height_small_still: {
            height: "100",
            size: "8917",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "100",
          },
          original: {
            frames: "51",
            hash: "62680279da682ceef0c73a34726fcce3",
            height: "400",
            mp4:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "197631",
            size: "4227596",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "612356",
            width: "400",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "162973",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "28926",
            width: "200",
          },
          downsized_still: {
            height: "250",
            size: "38849",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy-tumblr_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-tumblr_s.gif",
            width: "250",
          },
          fixed_height_still: {
            height: "200",
            size: "27067",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "200",
          },
          downsized_medium: {
            height: "400",
            size: "4227596",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "400",
          },
          downsized: {
            height: "250",
            size: "1770665",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy-tumblr.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-tumblr.gif",
            width: "250",
          },
          preview_webp: {
            height: "255",
            size: "48922",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "255",
          },
          original_mp4: {
            height: "480",
            mp4:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "197631",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "23723",
            size: "364634",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "97168",
            width: "100",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "54104",
            size: "1216532",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "230422",
            width: "200",
          },
          downsized_small: {
            height: "400",
            mp4:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "185460",
            width: "400",
          },
          preview: {
            height: "320",
            mp4:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "27236",
            width: "320",
          },
          fixed_width_downsampled: {
            height: "200",
            size: "162973",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "28926",
            width: "200",
          },
          fixed_width_small_still: {
            height: "100",
            size: "8917",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "23723",
            size: "364634",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "97168",
            width: "100",
          },
          original_still: {
            height: "400",
            size: "85718",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "400",
          },
          fixed_width_still: {
            height: "200",
            size: "27067",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "616465",
          },
          fixed_width: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "54104",
            size: "1216532",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "230422",
            width: "200",
          },
          preview_gif: {
            height: "104",
            size: "48776",
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "104",
          },
          "480w_still": {
            url:
              "https://media2.giphy.com/media/B2vBunhgt9Pc4/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "480",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPUIydkJ1bmhndDlQYzQmZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=B2vBunhgt9Pc4&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=B2vBunhgt9Pc4&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=B2vBunhgt9Pc4&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "9DctaOQnk7GX0LIxj9",
        url:
          "https://giphy.com/gifs/satisfying-oddlysatisfying-oddly-9DctaOQnk7GX0LIxj9",
        slug: "satisfying-oddlysatisfying-oddly-9DctaOQnk7GX0LIxj9",
        bitly_gif_url: "",
        bitly_url: "",
        embed_url: "https://giphy.com/embed/9DctaOQnk7GX0LIxj9",
        username: "",
        source:
          "https://www.reddit.com/r/oddlysatisfying/comments/arh8bh/its_feeding_time_for_these_golden_puppers/",
        title: "dogs satisfying GIF",
        rating: "g",
        content_url: "",
        source_tld: "www.reddit.com",
        source_post_url:
          "https://www.reddit.com/r/oddlysatisfying/comments/arh8bh/its_feeding_time_for_these_golden_puppers/",
        is_sticker: 0,
        import_datetime: "2019-02-17 06:21:26",
        trending_datetime: "2019-02-20 06:45:02",
        images: {
          hd: {
            height: "910",
            mp4:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy-hd.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-hd.mp4",
            mp4_size: "34040798",
            width: "728",
          },
          downsized_large: {
            height: "384",
            size: "7271091",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy-downsized-large.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-large.gif",
            width: "307",
          },
          fixed_height_small_still: {
            height: "100",
            size: "7885",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "80",
          },
          original: {
            frames: "450",
            hash: "dbe4677a927f0c88f68fb47c8791dc67",
            height: "480",
            mp4:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "7731626",
            size: "50597654",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "8683902",
            width: "384",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "136682",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "53052",
            width: "160",
          },
          downsized_still: {
            height: "204",
            size: "25194",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "164",
          },
          fixed_height_still: {
            height: "200",
            size: "23650",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "160",
          },
          downsized_medium: {
            height: "283",
            size: "3421221",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy-downsized-medium.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-medium.gif",
            width: "226",
          },
          downsized: {
            height: "204",
            size: "1415602",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "164",
          },
          preview_webp: {
            height: "112",
            size: "36780",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "90",
          },
          original_mp4: {
            height: "600",
            mp4:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "7731626",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "387656",
            size: "2755897",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "735266",
            width: "80",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "908847",
            size: "9617912",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "2023292",
            width: "160",
          },
          downsized_small: {
            height: "150",
            mp4:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "171854",
            width: "120",
          },
          preview: {
            height: "176",
            mp4:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "41440",
            width: "140",
          },
          fixed_width_downsampled: {
            height: "250",
            size: "204509",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "73538",
            width: "200",
          },
          fixed_width_small_still: {
            height: "125",
            size: "11089",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "125",
            mp4:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "42907",
            size: "4136002",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "1011350",
            width: "100",
          },
          original_still: {
            height: "480",
            size: "120893",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "384",
          },
          fixed_width_still: {
            height: "250",
            size: "34666",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "8660626",
          },
          fixed_width: {
            height: "250",
            mp4:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "1213442",
            size: "14570222",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "2794138",
            width: "200",
          },
          preview_gif: {
            height: "79",
            size: "47812",
            url:
              "https://media2.giphy.com/media/9DctaOQnk7GX0LIxj9/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "63",
          },
          "480w_still": {
            url:
              "https://media3.giphy.com/media/9DctaOQnk7GX0LIxj9/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "600",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPTlEY3RhT1FuazdHWDBMSXhqOSZldmVudF90eXBlPUdJRl9TRUFSQ0gmY2lkPTA1ZTgzOWY0YzAwZTEzMzkyY2I1YzAwNDRkYjhhNmZjZjk5MWE0NGE1MzJjOTIzYw",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=9DctaOQnk7GX0LIxj9&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=9DctaOQnk7GX0LIxj9&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=9DctaOQnk7GX0LIxj9&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "9JgfPxZ5pofIVjFleH",
        url: "https://giphy.com/gifs/9JgfPxZ5pofIVjFleH",
        slug: "9JgfPxZ5pofIVjFleH",
        bitly_gif_url: "https://gph.is/2oRH0GS",
        bitly_url: "https://gph.is/2oRH0GS",
        embed_url: "https://giphy.com/embed/9JgfPxZ5pofIVjFleH",
        username: "",
        source: "/r/gifs/comments/9e166n/dinner_time_dinner_time/",
        title: "dogs puppies GIF",
        rating: "g",
        content_url: "",
        source_tld: "",
        source_post_url: "/r/gifs/comments/9e166n/dinner_time_dinner_time/",
        is_sticker: 0,
        import_datetime: "2018-09-08 06:03:01",
        trending_datetime: "2019-03-24 05:30:01",
        images: {
          downsized_large: {
            height: "474",
            size: "3662904",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "320",
          },
          fixed_height_small_still: {
            height: "100",
            size: "4109",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "68",
          },
          original: {
            frames: "85",
            hash: "a703086c2dd2b53d750f23d738c9399d",
            height: "474",
            mp4:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1806580",
            size: "3662904",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "1954700",
            width: "320",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "71565",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "41976",
            width: "135",
          },
          downsized_still: {
            height: "379",
            size: "35425",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "256",
          },
          fixed_height_still: {
            height: "200",
            size: "12223",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "135",
          },
          downsized_medium: {
            height: "474",
            size: "3662904",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "320",
          },
          downsized: {
            height: "379",
            size: "1687758",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "256",
          },
          preview_webp: {
            height: "150",
            size: "48268",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "101",
          },
          original_mp4: {
            height: "710",
            mp4:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1806580",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "75285",
            size: "232771",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "203684",
            width: "68",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "213099",
            size: "805455",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "579316",
            width: "135",
          },
          downsized_small: {
            height: "188",
            mp4:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "101347",
            width: "126",
          },
          preview: {
            height: "262",
            mp4:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "38897",
            width: "176",
          },
          fixed_width_downsampled: {
            height: "296",
            size: "135507",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "72376",
            width: "200",
          },
          fixed_width_small_still: {
            height: "148",
            size: "7609",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "148",
            mp4:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "48877",
            size: "479548",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "374312",
            width: "100",
          },
          original_still: {
            height: "474",
            size: "47308",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "320",
          },
          fixed_width_still: {
            height: "296",
            size: "22831",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "2895611",
          },
          fixed_width: {
            height: "296",
            mp4:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "387019",
            size: "1603820",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "992250",
            width: "200",
          },
          preview_gif: {
            height: "137",
            size: "48018",
            url:
              "https://media3.giphy.com/media/9JgfPxZ5pofIVjFleH/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "92",
          },
          "480w_still": {
            url:
              "https://media1.giphy.com/media/9JgfPxZ5pofIVjFleH/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "711",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPTlKZ2ZQeFo1cG9mSVZqRmxlSCZldmVudF90eXBlPUdJRl9TRUFSQ0gmY2lkPTA1ZTgzOWY0YzAwZTEzMzkyY2I1YzAwNDRkYjhhNmZjZjk5MWE0NGE1MzJjOTIzYw",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=9JgfPxZ5pofIVjFleH&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=9JgfPxZ5pofIVjFleH&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=9JgfPxZ5pofIVjFleH&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "kreQ1pqlSzftm",
        url: "https://giphy.com/gifs/animal-dogs-kreQ1pqlSzftm",
        slug: "animal-dogs-kreQ1pqlSzftm",
        bitly_gif_url: "https://gph.is/1eOgTr6",
        bitly_url: "https://gph.is/1eOgTr6",
        embed_url: "https://giphy.com/embed/kreQ1pqlSzftm",
        username: "",
        source: "https://www.tumblr.com",
        title: "hot dog dogs GIF",
        rating: "g",
        content_url: "",
        source_tld: "www.tumblr.com",
        source_post_url: "https://www.tumblr.com",
        is_sticker: 0,
        import_datetime: "2014-02-11 19:47:08",
        trending_datetime: "2014-09-12 21:36:52",
        images: {
          downsized_large: {
            height: "300",
            size: "889442",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "400",
          },
          fixed_height_small_still: {
            height: "100",
            size: "5825",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "134",
          },
          original: {
            frames: "24",
            hash: "d563cc9b9121bacaaed0e53fa7bd93c8",
            height: "300",
            mp4:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1168692",
            size: "889442",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "891578",
            width: "400",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "146405",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "82430",
            width: "267",
          },
          downsized_still: {
            height: "300",
            size: "889442",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "400",
          },
          fixed_height_still: {
            height: "200",
            size: "24033",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "267",
          },
          downsized_medium: {
            height: "300",
            size: "889442",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "400",
          },
          downsized: {
            height: "300",
            size: "889442",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "400",
          },
          preview_webp: {
            height: "76",
            size: "20202",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "102",
          },
          original_mp4: {
            height: "360",
            mp4:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1168692",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "52384",
            size: "134343",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "75362",
            width: "134",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "228161",
            size: "558932",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "263126",
            width: "267",
          },
          downsized_small: {
            height: "144",
            mp4:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "52174",
            width: "192",
          },
          preview: {
            height: "122",
            mp4:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "43110",
            width: "162",
          },
          fixed_width_downsampled: {
            height: "150",
            size: "76337",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "47692",
            width: "200",
          },
          fixed_width_small_still: {
            height: "75",
            size: "3988",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "75",
            mp4:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "31617",
            size: "83401",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "49864",
            width: "100",
          },
          original_still: {
            height: "300",
            size: "36228",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "400",
          },
          fixed_width_still: {
            height: "150",
            size: "12589",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "5525025",
          },
          fixed_width: {
            height: "150",
            mp4:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "114384",
            size: "290001",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "139996",
            width: "200",
          },
          preview_gif: {
            height: "63",
            size: "49371",
            url:
              "https://media3.giphy.com/media/kreQ1pqlSzftm/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "84",
          },
          "480w_still": {
            url:
              "https://media0.giphy.com/media/kreQ1pqlSzftm/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "360",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPWtyZVExcHFsU3pmdG0mZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=kreQ1pqlSzftm&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=kreQ1pqlSzftm&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=kreQ1pqlSzftm&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "12DNVFxZZqp7AQ",
        url: "https://giphy.com/gifs/12DNVFxZZqp7AQ",
        slug: "12DNVFxZZqp7AQ",
        bitly_gif_url: "https://gph.is/29azJZN",
        bitly_url: "https://gph.is/29azJZN",
        embed_url: "https://giphy.com/embed/12DNVFxZZqp7AQ",
        username: "",
        source: "https://imgur.com/gallery/35Dq8wf",
        title: "best friends dogs GIF",
        rating: "g",
        content_url: "",
        source_tld: "imgur.com",
        source_post_url: "https://imgur.com/gallery/35Dq8wf",
        is_sticker: 0,
        import_datetime: "2016-07-02 12:21:17",
        trending_datetime: "2018-04-09 17:15:01",
        images: {
          downsized_large: {
            height: "394",
            size: "2556424",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "422",
          },
          fixed_height_small_still: {
            height: "100",
            size: "6559",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "107",
          },
          original: {
            frames: "33",
            hash: "8ea477d99c764b8ef73c1f6b125f8e20",
            height: "394",
            mp4:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1215877",
            size: "2556424",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "987016",
            width: "422",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "110140",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "67578",
            width: "214",
          },
          downsized_still: {
            height: "394",
            size: "41795",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "422",
          },
          fixed_height_still: {
            height: "200",
            size: "17497",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "214",
          },
          downsized_medium: {
            height: "394",
            size: "2556424",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "422",
          },
          downsized: {
            height: "394",
            size: "1493312",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "422",
          },
          preview_webp: {
            height: "112",
            size: "33288",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "120",
          },
          original_mp4: {
            height: "448",
            mp4:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1215877",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "49349",
            size: "186726",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "94638",
            width: "107",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "153060",
            size: "553573",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "236654",
            width: "214",
          },
          downsized_small: {
            height: "164",
            mp4:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "55399",
            width: "175",
          },
          preview: {
            height: "168",
            mp4:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "39206",
            width: "179",
          },
          fixed_width_downsampled: {
            height: "187",
            size: "107612",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "61660",
            width: "200",
          },
          fixed_width_small_still: {
            height: "94",
            size: "5912",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "94",
            mp4:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "44320",
            size: "169966",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "87426",
            width: "100",
          },
          original_still: {
            height: "394",
            size: "79801",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "422",
          },
          fixed_width_still: {
            height: "187",
            size: "16022",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "4026936",
          },
          fixed_width: {
            height: "187",
            mp4:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "129561",
            size: "502374",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "217576",
            width: "200",
          },
          preview_gif: {
            height: "72",
            size: "49120",
            url:
              "https://media3.giphy.com/media/12DNVFxZZqp7AQ/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "77",
          },
          "480w_still": {
            url:
              "https://media4.giphy.com/media/12DNVFxZZqp7AQ/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "448",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPTEyRE5WRnhaWnFwN0FRJmV2ZW50X3R5cGU9R0lGX1NFQVJDSCZjaWQ9MDVlODM5ZjRjMDBlMTMzOTJjYjVjMDA0NGRiOGE2ZmNmOTkxYTQ0YTUzMmM5MjNj",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=12DNVFxZZqp7AQ&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=12DNVFxZZqp7AQ&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=12DNVFxZZqp7AQ&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "LlPGmmhr0GcKs",
        url: "https://giphy.com/gifs/ever-dive-LlPGmmhr0GcKs",
        slug: "ever-dive-LlPGmmhr0GcKs",
        bitly_gif_url: "https://gph.is/1AmQG9m",
        bitly_url: "https://gph.is/1AmQG9m",
        embed_url: "https://giphy.com/embed/LlPGmmhr0GcKs",
        username: "",
        source: "https://cheezburger.com/7907202048",
        title: "dogs pool GIF",
        rating: "g",
        content_url: "",
        source_tld: "cheezburger.com",
        source_post_url: "https://cheezburger.com/7907202048",
        is_sticker: 0,
        import_datetime: "2015-04-30 21:49:22",
        trending_datetime: "2015-05-04 19:56:26",
        images: {
          downsized_large: {
            height: "153",
            size: "1336874",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "250",
          },
          fixed_height_small_still: {
            height: "100",
            size: "10911",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "164",
          },
          original: {
            frames: "62",
            hash: "4bcee224ddb3f7895a5a242e41d3a16e",
            height: "153",
            mp4:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1820889",
            size: "1336874",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "580452",
            width: "250",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "204674",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "103288",
            width: "327",
          },
          downsized_still: {
            height: "153",
            size: "1336874",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "250",
          },
          fixed_height_still: {
            height: "200",
            size: "33169",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "327",
          },
          downsized_medium: {
            height: "153",
            size: "1336874",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "250",
          },
          downsized: {
            height: "153",
            size: "1336874",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "250",
          },
          preview_webp: {
            height: "90",
            size: "32174",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "148",
          },
          original_mp4: {
            height: "292",
            mp4:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1820889",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "151418",
            size: "563127",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "209840",
            width: "164",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "671453",
            size: "1837091",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "766164",
            width: "327",
          },
          downsized_small: {
            height: "92",
            mp4:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "75612",
            width: "151",
          },
          preview: {
            height: "120",
            mp4:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "43209",
            width: "197",
          },
          fixed_width_downsampled: {
            height: "122",
            size: "93452",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "42888",
            width: "200",
          },
          fixed_width_small_still: {
            height: "61",
            size: "4302",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "61",
            mp4:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "47092",
            size: "203165",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "102340",
            width: "100",
          },
          original_still: {
            height: "153",
            size: "24914",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "250",
          },
          fixed_width_still: {
            height: "122",
            size: "16423",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "3328969",
          },
          fixed_width: {
            height: "122",
            mp4:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "233306",
            size: "894646",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "292048",
            width: "200",
          },
          preview_gif: {
            height: "57",
            size: "47353",
            url:
              "https://media2.giphy.com/media/LlPGmmhr0GcKs/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "93",
          },
          "480w_still": {
            url:
              "https://media0.giphy.com/media/LlPGmmhr0GcKs/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "294",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPUxsUEdtbWhyMEdjS3MmZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=LlPGmmhr0GcKs&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=LlPGmmhr0GcKs&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=LlPGmmhr0GcKs&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "OsVHDytNJNQ7m",
        url: "https://giphy.com/gifs/cute-pretty-dogs-OsVHDytNJNQ7m",
        slug: "cute-pretty-dogs-OsVHDytNJNQ7m",
        bitly_gif_url: "https://gph.is/1ISjqht",
        bitly_url: "https://gph.is/1ISjqht",
        embed_url: "https://giphy.com/embed/OsVHDytNJNQ7m",
        username: "",
        source:
          "https://cheezburger.com/8488057856/funny-animated-gifs-hey-you-look-pretty-cute",
        title: "dogs wink GIF",
        rating: "g",
        content_url: "",
        source_tld: "cheezburger.com",
        source_post_url:
          "https://cheezburger.com/8488057856/funny-animated-gifs-hey-you-look-pretty-cute",
        is_sticker: 0,
        import_datetime: "2015-05-07 17:45:05",
        trending_datetime: "2016-07-12 13:45:01",
        images: {
          downsized_large: {
            height: "386",
            size: "1563161",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "400",
          },
          fixed_height_small_still: {
            height: "100",
            size: "5720",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "104",
          },
          original: {
            frames: "25",
            hash: "8065e04fb48293db9c1189a54a87823b",
            height: "386",
            mp4:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "405629",
            size: "1563161",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "492364",
            width: "400",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "103089",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "54710",
            width: "207",
          },
          downsized_still: {
            height: "386",
            size: "1563161",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "400",
          },
          fixed_height_still: {
            height: "200",
            size: "15137",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "207",
          },
          downsized_medium: {
            height: "386",
            size: "1563161",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "400",
          },
          downsized: {
            height: "386",
            size: "1563161",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "400",
          },
          preview_webp: {
            height: "130",
            size: "33054",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "134",
          },
          original_mp4: {
            height: "462",
            mp4:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "405629",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "15523",
            size: "124824",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "56452",
            width: "104",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "41692",
            size: "363583",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "126190",
            width: "207",
          },
          downsized_small: {
            height: "276",
            mp4:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "34278",
            width: "286",
          },
          preview: {
            height: "154",
            mp4:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "12791",
            width: "159",
          },
          fixed_width_downsampled: {
            height: "193",
            size: "96657",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "52340",
            width: "200",
          },
          fixed_width_small_still: {
            height: "97",
            size: "5474",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "97",
            mp4:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "13935",
            size: "118536",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "52992",
            width: "100",
          },
          original_still: {
            height: "386",
            size: "78983",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "400",
          },
          fixed_width_still: {
            height: "193",
            size: "14377",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "2678839",
          },
          fixed_width: {
            height: "193",
            mp4:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "38734",
            size: "345470",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "123392",
            width: "200",
          },
          preview_gif: {
            height: "72",
            size: "49126",
            url:
              "https://media1.giphy.com/media/OsVHDytNJNQ7m/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "75",
          },
          "480w_still": {
            url:
              "https://media2.giphy.com/media/OsVHDytNJNQ7m/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "463",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPU9zVkhEeXROSk5RN20mZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=OsVHDytNJNQ7m&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=OsVHDytNJNQ7m&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=OsVHDytNJNQ7m&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "d3erWmTEGXoiYVgY",
        url: "https://giphy.com/gifs/redandhowling-funny-cute-d3erWmTEGXoiYVgY",
        slug: "redandhowling-funny-cute-d3erWmTEGXoiYVgY",
        bitly_gif_url: "https://gph.is/2ni2FXr",
        bitly_url: "https://gph.is/2ni2FXr",
        embed_url: "https://giphy.com/embed/d3erWmTEGXoiYVgY",
        username: "redandhowling",
        source: "https://shop.redandhowling.com/",
        title: "Tired Good Morning GIF by Red & Howling",
        rating: "g",
        content_url: "",
        source_tld: "shop.redandhowling.com",
        source_post_url: "https://shop.redandhowling.com/",
        is_sticker: 0,
        import_datetime: "2018-01-27 06:14:05",
        trending_datetime: "2019-07-25 15:15:02",
        images: {
          hd: {
            height: "810",
            mp4:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy-hd.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-hd.mp4",
            mp4_size: "316666",
            width: "1080",
          },
          downsized_large: {
            height: "360",
            size: "273098",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          fixed_height_small_still: {
            height: "100",
            size: "5512",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "134",
          },
          original: {
            frames: "18",
            hash: "2ec1024afcabfc64aae3f82107427376",
            height: "360",
            mp4:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "79611",
            size: "273098",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "125630",
            width: "480",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "54229",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "52392",
            width: "267",
          },
          downsized_still: {
            height: "360",
            size: "273098",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "480",
          },
          fixed_height_still: {
            height: "200",
            size: "18942",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "267",
          },
          downsized_medium: {
            height: "360",
            size: "273098",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          downsized: {
            height: "360",
            size: "273098",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          preview_webp: {
            height: "178",
            size: "46600",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "238",
          },
          original_mp4: {
            height: "360",
            mp4:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "79611",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "11890",
            size: "42936",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "28756",
            width: "134",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "33514",
            size: "102935",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "70496",
            width: "267",
          },
          downsized_small: {
            height: "360",
            mp4:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "79611",
            width: "480",
          },
          preview: {
            height: "284",
            mp4:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "25753",
            width: "378",
          },
          fixed_width_downsampled: {
            height: "150",
            size: "35675",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "37748",
            width: "200",
          },
          fixed_width_small_still: {
            height: "75",
            size: "3858",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "75",
            mp4:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "8338",
            size: "29834",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "21074",
            width: "100",
          },
          original_still: {
            height: "360",
            size: "48284",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "480",
          },
          fixed_width_still: {
            height: "150",
            size: "13301",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "943174",
          },
          fixed_width: {
            height: "150",
            mp4:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "22266",
            size: "69674",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "48262",
            width: "200",
          },
          preview_gif: {
            height: "154",
            size: "49562",
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "205",
          },
          "480w_still": {
            url:
              "https://media1.giphy.com/media/d3erWmTEGXoiYVgY/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "360",
          },
        },
        user: {
          avatar_url:
            "https://media4.giphy.com/avatars/redandhowling/KBya1PlSw5HO.jpg",
          banner_image:
            "https://media4.giphy.com/headers/redandhowling/bluYWDAjbKPK.gif",
          banner_url:
            "https://media4.giphy.com/headers/redandhowling/bluYWDAjbKPK.gif",
          profile_url: "https://giphy.com/redandhowling/",
          username: "redandhowling",
          display_name: "Red & Howling",
          is_verified: true,
        },
        analytics_response_payload:
          "e=Z2lmX2lkPWQzZXJXbVRFR1hvaVlWZ1kmZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=d3erWmTEGXoiYVgY&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=d3erWmTEGXoiYVgY&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=d3erWmTEGXoiYVgY&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "XIRLhgiytlavZvuuXS",
        url: "https://giphy.com/gifs/dog-dogs-mustlovedogs-XIRLhgiytlavZvuuXS",
        slug: "dog-dogs-mustlovedogs-XIRLhgiytlavZvuuXS",
        bitly_gif_url: "https://gph.is/g/Ev9Q1w4",
        bitly_url: "https://gph.is/g/Ev9Q1w4",
        embed_url: "https://giphy.com/embed/XIRLhgiytlavZvuuXS",
        username: "redandhowling",
        source: "https://redandhowling.com",
        title: "dogs fart GIF by Red & Howling",
        rating: "g",
        content_url: "",
        source_tld: "redandhowling.com",
        source_post_url: "https://redandhowling.com",
        is_sticker: 0,
        import_datetime: "2019-04-18 02:41:28",
        trending_datetime: "0000-00-00 00:00:00",
        images: {
          hd: {
            height: "1200",
            mp4:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy-hd.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-hd.mp4",
            mp4_size: "414479",
            width: "1200",
          },
          downsized_large: {
            height: "480",
            size: "422772",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          fixed_height_small_still: {
            height: "100",
            size: "4136",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "100",
          },
          original: {
            frames: "50",
            hash: "e699965d547e6e1f8307edebff23e02c",
            height: "480",
            mp4:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "69122",
            size: "422772",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "177352",
            width: "480",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "31999",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "35148",
            width: "200",
          },
          downsized_still: {
            height: "480",
            size: "422772",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "480",
          },
          fixed_height_still: {
            height: "200",
            size: "10865",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "200",
          },
          downsized_medium: {
            height: "480",
            size: "422772",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          downsized: {
            height: "480",
            size: "422772",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          preview_webp: {
            height: "210",
            size: "43774",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "210",
          },
          original_mp4: {
            height: "480",
            mp4:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "69122",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "7346",
            size: "37837",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "17678",
            width: "100",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "16623",
            size: "88697",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "81102",
            width: "200",
          },
          downsized_small: {
            height: "480",
            mp4:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "69122",
            width: "480",
          },
          preview: {
            height: "480",
            mp4:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "38957",
            width: "480",
          },
          fixed_width_downsampled: {
            height: "200",
            size: "31999",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "35148",
            width: "200",
          },
          fixed_width_small_still: {
            height: "100",
            size: "4136",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "100",
            mp4:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "7346",
            size: "37837",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "17678",
            width: "100",
          },
          original_still: {
            height: "480",
            size: "54489",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "480",
          },
          fixed_width_still: {
            height: "200",
            size: "10865",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "314673",
          },
          fixed_width: {
            height: "200",
            mp4:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "16623",
            size: "88697",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "81102",
            width: "200",
          },
          preview_gif: {
            height: "166",
            size: "48698",
            url:
              "https://media0.giphy.com/media/XIRLhgiytlavZvuuXS/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "166",
          },
          "480w_still": {
            url:
              "https://media3.giphy.com/media/XIRLhgiytlavZvuuXS/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "480",
          },
        },
        user: {
          avatar_url:
            "https://media4.giphy.com/avatars/redandhowling/KBya1PlSw5HO.jpg",
          banner_image:
            "https://media4.giphy.com/headers/redandhowling/bluYWDAjbKPK.gif",
          banner_url:
            "https://media4.giphy.com/headers/redandhowling/bluYWDAjbKPK.gif",
          profile_url: "https://giphy.com/redandhowling/",
          username: "redandhowling",
          display_name: "Red & Howling",
          is_verified: true,
        },
        analytics_response_payload:
          "e=Z2lmX2lkPVhJUkxoZ2l5dGxhdlp2dXVYUyZldmVudF90eXBlPUdJRl9TRUFSQ0gmY2lkPTA1ZTgzOWY0YzAwZTEzMzkyY2I1YzAwNDRkYjhhNmZjZjk5MWE0NGE1MzJjOTIzYw",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=XIRLhgiytlavZvuuXS&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=XIRLhgiytlavZvuuXS&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=XIRLhgiytlavZvuuXS&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "YIW0KqAQShjCE",
        url: "https://giphy.com/gifs/tail-another-wagging-YIW0KqAQShjCE",
        slug: "tail-another-wagging-YIW0KqAQShjCE",
        bitly_gif_url: "https://gph.is/1MNVbzy",
        bitly_url: "https://gph.is/1MNVbzy",
        embed_url: "https://giphy.com/embed/YIW0KqAQShjCE",
        username: "",
        source:
          "https://www.reddit.com/r/gifs/comments/3u0np4/the_tail_wagging_another_dog/",
        title: "annoyed dog GIF",
        rating: "g",
        content_url: "",
        source_tld: "www.reddit.com",
        source_post_url:
          "https://www.reddit.com/r/gifs/comments/3u0np4/the_tail_wagging_another_dog/",
        is_sticker: 0,
        import_datetime: "2015-11-24 01:12:07",
        trending_datetime: "2017-11-26 02:15:01",
        images: {
          downsized_large: {
            height: "265",
            size: "2088334",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "360",
          },
          fixed_height_small_still: {
            height: "100",
            size: "8281",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "136",
          },
          original: {
            frames: "69",
            hash: "f02b31e2de8fefe7c7c94ffa3685c02b",
            height: "265",
            mp4:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1647897",
            size: "2088334",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "1495146",
            width: "360",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "140426",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "78070",
            width: "272",
          },
          downsized_still: {
            height: "265",
            size: "27803",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "360",
          },
          fixed_height_still: {
            height: "200",
            size: "23052",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "272",
          },
          downsized_medium: {
            height: "265",
            size: "2088334",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "360",
          },
          downsized: {
            height: "265",
            size: "1363331",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "360",
          },
          preview_webp: {
            height: "90",
            size: "27892",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "122",
          },
          original_mp4: {
            height: "352",
            mp4:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1647897",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "105149",
            size: "444304",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "209100",
            width: "136",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "385578",
            size: "1460151",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "599046",
            width: "272",
          },
          downsized_small: {
            height: "110",
            mp4:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "61536",
            width: "150",
          },
          preview: {
            height: "154",
            mp4:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "39615",
            width: "210",
          },
          fixed_width_downsampled: {
            height: "147",
            size: "81674",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "44488",
            width: "200",
          },
          fixed_width_small_still: {
            height: "74",
            size: "4892",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "74",
            mp4:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "47575",
            size: "274803",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "140742",
            width: "100",
          },
          original_still: {
            height: "265",
            size: "33122",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "360",
          },
          fixed_width_still: {
            height: "147",
            size: "18411",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "2960789",
          },
          fixed_width: {
            height: "147",
            mp4:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "208524",
            size: "916139",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "355924",
            width: "200",
          },
          preview_gif: {
            height: "58",
            size: "49496",
            url:
              "https://media2.giphy.com/media/YIW0KqAQShjCE/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "79",
          },
          "480w_still": {
            url:
              "https://media1.giphy.com/media/YIW0KqAQShjCE/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "353",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPVlJVzBLcUFRU2hqQ0UmZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=YIW0KqAQShjCE&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=YIW0KqAQShjCE&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=YIW0KqAQShjCE&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "3o6ozzX4mAcwkkgzG8",
        url:
          "https://giphy.com/gifs/natgeowild-dogs-nat-geo-wild-barkfest-3o6ozzX4mAcwkkgzG8",
        slug: "natgeowild-dogs-nat-geo-wild-barkfest-3o6ozzX4mAcwkkgzG8",
        bitly_gif_url: "https://gph.is/20HFylD",
        bitly_url: "https://gph.is/20HFylD",
        embed_url: "https://giphy.com/embed/3o6ozzX4mAcwkkgzG8",
        username: "natgeowild",
        source: "https://natgeowild.com",
        title: "dogs scooter GIF by Nat Geo Wild ",
        rating: "g",
        content_url: "",
        source_tld: "natgeowild.com",
        source_post_url: "https://natgeowild.com",
        is_sticker: 0,
        import_datetime: "2016-04-15 13:44:55",
        trending_datetime: "2016-08-27 07:15:01",
        images: {
          downsized_large: {
            height: "338",
            size: "1977570",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "600",
          },
          fixed_height_small_still: {
            height: "100",
            size: "10881",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "178",
          },
          original: {
            frames: "23",
            hash: "adc7a9608987a6c541cba881209bf2c7",
            height: "338",
            mp4:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "529700",
            size: "1977570",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "987422",
            width: "600",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "179482",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "127248",
            width: "355",
          },
          downsized_still: {
            height: "338",
            size: "1977570",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "600",
          },
          fixed_height_still: {
            height: "200",
            size: "28120",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "355",
          },
          downsized_medium: {
            height: "338",
            size: "1977570",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "600",
          },
          downsized: {
            height: "338",
            size: "1977570",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "600",
          },
          preview_webp: {
            height: "76",
            size: "31368",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "134",
          },
          original_mp4: {
            height: "270",
            mp4:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "529700",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "86524",
            size: "239178",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "133292",
            width: "178",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "289258",
            size: "648524",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "463826",
            width: "355",
          },
          downsized_small: {
            height: "152",
            mp4:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "97761",
            width: "269",
          },
          preview: {
            height: "120",
            mp4:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "47356",
            width: "213",
          },
          fixed_width_downsampled: {
            height: "113",
            size: "85350",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "43850",
            width: "200",
          },
          fixed_width_small_still: {
            height: "57",
            size: "3994",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "57",
            mp4:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "33170",
            size: "77254",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "49060",
            width: "100",
          },
          original_still: {
            height: "338",
            size: "91483",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "600",
          },
          fixed_width_still: {
            height: "113",
            size: "13710",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "2816250",
          },
          fixed_width: {
            height: "113",
            mp4:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "102816",
            size: "337195",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "163786",
            width: "200",
          },
          preview_gif: {
            height: "77",
            size: "46458",
            url:
              "https://media3.giphy.com/media/3o6ozzX4mAcwkkgzG8/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "137",
          },
          "480w_still": {
            url:
              "https://media0.giphy.com/media/3o6ozzX4mAcwkkgzG8/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "270",
          },
        },
        user: {
          avatar_url:
            "https://media3.giphy.com/avatars/natgeowild/zBojD0lYteHi.jpg",
          banner_image:
            "https://media3.giphy.com/headers/natgeowild/UplNMTnbMAkp.jpg",
          banner_url:
            "https://media3.giphy.com/headers/natgeowild/UplNMTnbMAkp.jpg",
          profile_url: "https://giphy.com/natgeowild/",
          username: "natgeowild",
          display_name: "Nat Geo Wild",
          is_verified: true,
        },
        analytics_response_payload:
          "e=Z2lmX2lkPTNvNm96elg0bUFjd2trZ3pHOCZldmVudF90eXBlPUdJRl9TRUFSQ0gmY2lkPTA1ZTgzOWY0YzAwZTEzMzkyY2I1YzAwNDRkYjhhNmZjZjk5MWE0NGE1MzJjOTIzYw",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=3o6ozzX4mAcwkkgzG8&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=3o6ozzX4mAcwkkgzG8&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=3o6ozzX4mAcwkkgzG8&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "avWgZ78c6frcCpju5H",
        url: "https://giphy.com/gifs/cute-aww-eyebleach-avWgZ78c6frcCpju5H",
        slug: "cute-aww-eyebleach-avWgZ78c6frcCpju5H",
        bitly_gif_url: "https://gph.is/2ydn86e",
        bitly_url: "https://gph.is/2ydn86e",
        embed_url: "https://giphy.com/embed/avWgZ78c6frcCpju5H",
        username: "",
        source:
          "https://www.reddit.com/r/Eyebleach/comments/9n25q3/travel_buddies/",
        title: "adorable dogs GIF",
        rating: "g",
        content_url: "",
        source_tld: "www.reddit.com",
        source_post_url:
          "https://www.reddit.com/r/Eyebleach/comments/9n25q3/travel_buddies/",
        is_sticker: 0,
        import_datetime: "2018-10-11 06:19:04",
        trending_datetime: "0000-00-00 00:00:00",
        images: {
          hd: {
            height: "1200",
            mp4:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy-hd.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-hd.mp4",
            mp4_size: "5143892",
            width: "960",
          },
          downsized_large: {
            height: "384",
            size: "6911661",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy-downsized-large.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-large.gif",
            width: "307",
          },
          fixed_height_small_still: {
            height: "100",
            size: "7968",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "80",
          },
          original: {
            frames: "225",
            hash: "da7d20f9d57208bb710fc3a0a4a7d6de",
            height: "480",
            mp4:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1664792",
            size: "22796976",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "5720256",
            width: "384",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "150632",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "44930",
            width: "160",
          },
          downsized_still: {
            height: "216",
            size: "28968",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "172",
          },
          fixed_height_still: {
            height: "200",
            size: "25028",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "160",
          },
          downsized_medium: {
            height: "299",
            size: "3304785",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy-downsized-medium.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-medium.gif",
            width: "239",
          },
          downsized: {
            height: "216",
            size: "1422423",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "172",
          },
          preview_webp: {
            height: "147",
            size: "49222",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "118",
          },
          original_mp4: {
            height: "480",
            mp4:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1664792",
            width: "384",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "233536",
            size: "1201306",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "618504",
            width: "80",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "559142",
            size: "4593058",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "1663994",
            width: "160",
          },
          downsized_small: {
            height: "152",
            mp4:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "167768",
            width: "120",
          },
          preview: {
            height: "340",
            mp4:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "30420",
            width: "272",
          },
          fixed_width_downsampled: {
            height: "250",
            size: "218843",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "61800",
            width: "200",
          },
          fixed_width_small_still: {
            height: "125",
            size: "11377",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "125",
            mp4:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "42506",
            size: "1808507",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "853532",
            width: "100",
          },
          original_still: {
            height: "480",
            size: "106125",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "384",
          },
          fixed_width_still: {
            height: "250",
            size: "35809",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "1519698",
          },
          fixed_width: {
            height: "250",
            mp4:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "757498",
            size: "8003266",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "2301830",
            width: "200",
          },
          preview_gif: {
            height: "104",
            size: "48905",
            url:
              "https://media0.giphy.com/media/avWgZ78c6frcCpju5H/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "83",
          },
          "480w_still": {
            url:
              "https://media2.giphy.com/media/avWgZ78c6frcCpju5H/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "600",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPWF2V2daNzhjNmZyY0NwanU1SCZldmVudF90eXBlPUdJRl9TRUFSQ0gmY2lkPTA1ZTgzOWY0YzAwZTEzMzkyY2I1YzAwNDRkYjhhNmZjZjk5MWE0NGE1MzJjOTIzYw",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=avWgZ78c6frcCpju5H&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=avWgZ78c6frcCpju5H&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=avWgZ78c6frcCpju5H&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "101kC6OJncUhi0",
        url: "https://giphy.com/gifs/dogs-pets-cuteness-101kC6OJncUhi0",
        slug: "dogs-pets-cuteness-101kC6OJncUhi0",
        bitly_gif_url: "https://gph.is/1UOpTf4",
        bitly_url: "https://gph.is/1UOpTf4",
        embed_url: "https://giphy.com/embed/101kC6OJncUhi0",
        username: "",
        source: "https://wifflegif.com",
        title: "dogs pets GIF",
        rating: "g",
        content_url: "",
        source_tld: "wifflegif.com",
        source_post_url: "https://wifflegif.com",
        is_sticker: 0,
        import_datetime: "2016-06-13 17:24:29",
        trending_datetime: "2019-09-12 18:45:06",
        images: {
          downsized_large: {
            height: "259",
            size: "636257",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "459",
          },
          fixed_height_small_still: {
            height: "100",
            size: "6421",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "177",
          },
          original: {
            frames: "23",
            hash: "0d80ab56a49dc6d4afab66c98032071b",
            height: "259",
            mp4:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "185127",
            size: "636257",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "160970",
            width: "459",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "105569",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "68366",
            width: "354",
          },
          downsized_still: {
            height: "259",
            size: "636257",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "459",
          },
          fixed_height_still: {
            height: "200",
            size: "15929",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "354",
          },
          downsized_medium: {
            height: "259",
            size: "636257",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "459",
          },
          downsized: {
            height: "259",
            size: "636257",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "459",
          },
          preview_webp: {
            height: "194",
            size: "49892",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "344",
          },
          original_mp4: {
            height: "270",
            mp4:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "185127",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/101kC6OJncUhi0/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "38036",
            size: "131438",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media2.giphy.com/media/101kC6OJncUhi0/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "51336",
            width: "177",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "106268",
            size: "350509",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "115966",
            width: "354",
          },
          downsized_small: {
            height: "258",
            mp4:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "174739",
            width: "458",
          },
          preview: {
            height: "198",
            mp4:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "42528",
            width: "351",
          },
          fixed_width_downsampled: {
            height: "113",
            size: "42980",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "26622",
            width: "200",
          },
          fixed_width_small_still: {
            height: "57",
            size: "3349",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "57",
            mp4:
              "https://media2.giphy.com/media/101kC6OJncUhi0/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "17259",
            size: "59693",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media2.giphy.com/media/101kC6OJncUhi0/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "25888",
            width: "100",
          },
          original_still: {
            height: "259",
            size: "41936",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "459",
          },
          fixed_width_still: {
            height: "113",
            size: "8836",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "1078891",
          },
          fixed_width: {
            height: "113",
            mp4:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "43313",
            size: "152779",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media2.giphy.com/media/101kC6OJncUhi0/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "57912",
            width: "200",
          },
          preview_gif: {
            height: "53",
            size: "49960",
            url:
              "https://media2.giphy.com/media/101kC6OJncUhi0/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "94",
          },
          "480w_still": {
            url:
              "https://media3.giphy.com/media/101kC6OJncUhi0/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "271",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPTEwMWtDNk9KbmNVaGkwJmV2ZW50X3R5cGU9R0lGX1NFQVJDSCZjaWQ9MDVlODM5ZjRjMDBlMTMzOTJjYjVjMDA0NGRiOGE2ZmNmOTkxYTQ0YTUzMmM5MjNj",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=101kC6OJncUhi0&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=101kC6OJncUhi0&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=101kC6OJncUhi0&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "4VWrHajMlkEP6FNqQY",
        url:
          "https://giphy.com/gifs/spring-homemade-enjoying-4VWrHajMlkEP6FNqQY",
        slug: "spring-homemade-enjoying-4VWrHajMlkEP6FNqQY",
        bitly_gif_url: "https://gph.is/2HMu6lR",
        bitly_url: "https://gph.is/2HMu6lR",
        embed_url: "https://giphy.com/embed/4VWrHajMlkEP6FNqQY",
        username: "",
        source:
          "https://www.reddit.com/r/gifs/comments/806qft/they_are_enjoying_the_homemade_hot_spring/",
        title: "dogs enjoying GIF",
        rating: "g",
        content_url: "",
        source_tld: "www.reddit.com",
        source_post_url:
          "https://www.reddit.com/r/gifs/comments/806qft/they_are_enjoying_the_homemade_hot_spring/",
        is_sticker: 0,
        import_datetime: "2018-02-25 19:30:19",
        trending_datetime: "2019-08-09 09:00:01",
        images: {
          hd: {
            height: "728",
            mp4:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy-hd.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-hd.mp4",
            mp4_size: "15440800",
            width: "728",
          },
          downsized_large: {
            height: "728",
            size: "7252311",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy-downsized-large.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-large.gif",
            width: "728",
          },
          fixed_height_small_still: {
            height: "100",
            size: "2916",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "100",
          },
          original: {
            frames: "360",
            hash: "5c08d9142966d0d9197bc04da24aa7a6",
            height: "728",
            mp4:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "2502771",
            size: "15966926",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "18569048",
            width: "728",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "54947",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "50894",
            width: "200",
          },
          downsized_still: {
            height: "437",
            size: "47365",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "437",
          },
          fixed_height_still: {
            height: "200",
            size: "9121",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "200",
          },
          downsized_medium: {
            height: "582",
            size: "4018877",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy-downsized-medium.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-medium.gif",
            width: "582",
          },
          downsized: {
            height: "437",
            size: "1828612",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "437",
          },
          preview_webp: {
            height: "170",
            size: "49888",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "170",
          },
          original_mp4: {
            height: "480",
            mp4:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "2502771",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "128501",
            size: "323744",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "436304",
            width: "100",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "391480",
            size: "1184918",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "1460438",
            width: "200",
          },
          downsized_small: {
            height: "232",
            mp4:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "173273",
            width: "232",
          },
          preview: {
            height: "162",
            mp4:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "14958",
            width: "162",
          },
          fixed_width_downsampled: {
            height: "200",
            size: "54947",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "50894",
            width: "200",
          },
          fixed_width_small_still: {
            height: "100",
            size: "2916",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "46030",
            size: "323744",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "436304",
            width: "100",
          },
          original_still: {
            height: "728",
            size: "117839",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "728",
          },
          fixed_width_still: {
            height: "200",
            size: "9121",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "3182692",
          },
          fixed_width: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "391480",
            size: "1184918",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "1460438",
            width: "200",
          },
          preview_gif: {
            height: "165",
            size: "49452",
            url:
              "https://media2.giphy.com/media/4VWrHajMlkEP6FNqQY/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "165",
          },
          "480w_still": {
            url:
              "https://media1.giphy.com/media/4VWrHajMlkEP6FNqQY/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "480",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPTRWV3JIYWpNbGtFUDZGTnFRWSZldmVudF90eXBlPUdJRl9TRUFSQ0gmY2lkPTA1ZTgzOWY0YzAwZTEzMzkyY2I1YzAwNDRkYjhhNmZjZjk5MWE0NGE1MzJjOTIzYw",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=4VWrHajMlkEP6FNqQY&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=4VWrHajMlkEP6FNqQY&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=4VWrHajMlkEP6FNqQY&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "ZNegC7wFpuQT7nurZ0",
        url: "https://giphy.com/gifs/thedodo-dog-dogs-ZNegC7wFpuQT7nurZ0",
        slug: "thedodo-dog-dogs-ZNegC7wFpuQT7nurZ0",
        bitly_gif_url: "https://gph.is/2JVGcda",
        bitly_url: "https://gph.is/2JVGcda",
        embed_url: "https://giphy.com/embed/ZNegC7wFpuQT7nurZ0",
        username: "thedodo",
        source: "",
        title: "dog GIF by The Dodo",
        rating: "g",
        content_url: "",
        source_tld: "",
        source_post_url: "",
        is_sticker: 0,
        import_datetime: "2018-04-18 17:07:39",
        trending_datetime: "2018-05-17 22:00:01",
        images: {
          hd: {
            height: "1080",
            mp4:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy-hd.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-hd.mp4",
            mp4_size: "1817247",
            width: "1080",
          },
          downsized_large: {
            height: "480",
            size: "2019432",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          fixed_height_small_still: {
            height: "100",
            size: "7938",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "100",
          },
          original: {
            frames: "16",
            hash: "888c9d0ad2a409caf56617428ab5ef87",
            height: "480",
            mp4:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "639470",
            size: "2019432",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "715086",
            width: "480",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "137831",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "90120",
            width: "200",
          },
          downsized_still: {
            height: "480",
            size: "83664",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "480",
          },
          fixed_height_still: {
            height: "200",
            size: "22179",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "200",
          },
          downsized_medium: {
            height: "480",
            size: "2019432",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          downsized: {
            height: "480",
            size: "1311070",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "480",
          },
          preview_webp: {
            height: "96",
            size: "35518",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "96",
          },
          original_mp4: {
            height: "480",
            mp4:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "639470",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "53530",
            size: "103003",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "61470",
            width: "100",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "169206",
            size: "335214",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "192546",
            width: "200",
          },
          downsized_small: {
            height: "268",
            mp4:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "151197",
            width: "268",
          },
          preview: {
            height: "150",
            mp4:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "49142",
            width: "150",
          },
          fixed_width_downsampled: {
            height: "200",
            size: "137831",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "90120",
            width: "200",
          },
          fixed_width_small_still: {
            height: "100",
            size: "7938",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "100",
            mp4:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "42615",
            size: "103003",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "61470",
            width: "100",
          },
          original_still: {
            height: "480",
            size: "128825",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "480",
          },
          fixed_width_still: {
            height: "200",
            size: "22179",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "8457767",
          },
          fixed_width: {
            height: "200",
            mp4:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "169206",
            size: "335214",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "192546",
            width: "200",
          },
          preview_gif: {
            height: "92",
            size: "49045",
            url:
              "https://media3.giphy.com/media/ZNegC7wFpuQT7nurZ0/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "92",
          },
          "480w_still": {
            url:
              "https://media4.giphy.com/media/ZNegC7wFpuQT7nurZ0/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "480",
          },
        },
        user: {
          avatar_url:
            "https://media0.giphy.com/avatars/thedodo/Ro5ehorTw8Eu.png",
          banner_image:
            "https://media0.giphy.com/headers/thedodo/9Kx3dfPvUroA.png",
          banner_url:
            "https://media0.giphy.com/headers/thedodo/9Kx3dfPvUroA.png",
          profile_url: "https://giphy.com/thedodo/",
          username: "thedodo",
          display_name: "The Dodo",
          is_verified: true,
        },
        analytics_response_payload:
          "e=Z2lmX2lkPVpOZWdDN3dGcHVRVDdudXJaMCZldmVudF90eXBlPUdJRl9TRUFSQ0gmY2lkPTA1ZTgzOWY0YzAwZTEzMzkyY2I1YzAwNDRkYjhhNmZjZjk5MWE0NGE1MzJjOTIzYw",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=ZNegC7wFpuQT7nurZ0&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=ZNegC7wFpuQT7nurZ0&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=ZNegC7wFpuQT7nurZ0&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "LYRT0ChB4CGnm",
        url: "https://giphy.com/gifs/french-bulldog-LYRT0ChB4CGnm",
        slug: "french-bulldog-LYRT0ChB4CGnm",
        bitly_gif_url: "https://gph.is/2aUC9jW",
        bitly_url: "https://gph.is/2aUC9jW",
        embed_url: "https://giphy.com/embed/LYRT0ChB4CGnm",
        username: "",
        source:
          "https://www.urdogs.com/this-dog-falls-sleep-anywhere-in-under-1-minute-even-there/",
        title: "french bulldog whatever GIF",
        rating: "g",
        content_url: "",
        source_tld: "www.urdogs.com",
        source_post_url:
          "https://www.urdogs.com/this-dog-falls-sleep-anywhere-in-under-1-minute-even-there/",
        is_sticker: 0,
        import_datetime: "2016-08-04 22:44:10",
        trending_datetime: "2017-04-19 15:30:01",
        images: {
          downsized_large: {
            height: "270",
            size: "1580279",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          fixed_height_small_still: {
            height: "100",
            size: "9299",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "178",
          },
          original: {
            frames: "63",
            hash: "1c10bfa71c1bb451fde85ef7f6be8bbc",
            height: "270",
            mp4:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1403547",
            size: "1580279",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "1394920",
            width: "480",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "141243",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "93178",
            width: "356",
          },
          downsized_still: {
            height: "270",
            size: "1580279",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "480",
          },
          fixed_height_still: {
            height: "200",
            size: "22556",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "356",
          },
          downsized_medium: {
            height: "270",
            size: "1580279",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          downsized: {
            height: "270",
            size: "1580279",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            width: "480",
          },
          preview_webp: {
            height: "88",
            size: "25848",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "156",
          },
          original_mp4: {
            height: "270",
            mp4:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "1403547",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "58287",
            size: "466979",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "180542",
            width: "178",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "377527",
            size: "1374240",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "591102",
            width: "356",
          },
          downsized_small: {
            height: "108",
            mp4:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "20430",
            width: "192",
          },
          preview: {
            height: "140",
            mp4:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "36304",
            width: "248",
          },
          fixed_width_downsampled: {
            height: "113",
            size: "57112",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "33834",
            width: "200",
          },
          fixed_width_small_still: {
            height: "57",
            size: "3630",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "57",
            mp4:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "15726",
            size: "178293",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "82798",
            width: "100",
          },
          original_still: {
            height: "270",
            size: "25014",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "480",
          },
          fixed_width_still: {
            height: "113",
            size: "11616",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "5568047",
          },
          fixed_width: {
            height: "113",
            mp4:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "70450",
            size: "587706",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "207850",
            width: "200",
          },
          preview_gif: {
            height: "53",
            size: "47047",
            url:
              "https://media3.giphy.com/media/LYRT0ChB4CGnm/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "94",
          },
          "480w_still": {
            url:
              "https://media4.giphy.com/media/LYRT0ChB4CGnm/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "270",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPUxZUlQwQ2hCNENHbm0mZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=LYRT0ChB4CGnm&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=LYRT0ChB4CGnm&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=LYRT0ChB4CGnm&action_type=SENT",
          },
        },
      },
      {
        type: "gif",
        id: "UlN4m79dsYXte",
        url: "https://giphy.com/gifs/couple-UlN4m79dsYXte",
        slug: "couple-UlN4m79dsYXte",
        bitly_gif_url: "https://gph.is/21X6kaF",
        bitly_url: "https://gph.is/21X6kaF",
        embed_url: "https://giphy.com/embed/UlN4m79dsYXte",
        username: "",
        source:
          "https://www.reddit.com/r/gifs/comments/49evvp/ridiculously_photogenic_couple/",
        title: "dog pals couple GIF",
        rating: "g",
        content_url: "",
        source_tld: "www.reddit.com",
        source_post_url:
          "https://www.reddit.com/r/gifs/comments/49evvp/ridiculously_photogenic_couple/",
        is_sticker: 0,
        import_datetime: "2016-03-07 21:45:27",
        trending_datetime: "2016-03-08 08:15:02",
        images: {
          downsized_large: {
            height: "360",
            size: "5433025",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy-downsized-large.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-large.gif",
            width: "360",
          },
          fixed_height_small_still: {
            height: "100",
            size: "7078",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/100_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100_s.gif",
            width: "100",
          },
          original: {
            frames: "174",
            hash: "f8c509abd73c293cfd49b7f07b0b3baf",
            height: "360",
            mp4:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "5853524",
            size: "16067332",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.gif",
            webp:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.webp",
            webp_size: "5728556",
            width: "360",
          },
          fixed_height_downsampled: {
            height: "200",
            size: "126370",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.gif",
            webp:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_d.webp",
            webp_size: "82354",
            width: "200",
          },
          downsized_still: {
            height: "226",
            size: "30404",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy-downsized_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized_s.gif",
            width: "226",
          },
          fixed_height_still: {
            height: "200",
            size: "21758",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200_s.gif",
            width: "200",
          },
          downsized_medium: {
            height: "288",
            size: "3422066",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy-downsized-medium.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-medium.gif",
            width: "288",
          },
          downsized: {
            height: "226",
            size: "1329191",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy-downsized.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized.gif",
            width: "226",
          },
          preview_webp: {
            height: "96",
            size: "28788",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy-preview.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.webp",
            width: "96",
          },
          original_mp4: {
            height: "480",
            mp4:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy.mp4",
            mp4_size: "5853524",
            width: "480",
          },
          fixed_height_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/UlN4m79dsYXte/100.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.mp4",
            mp4_size: "267045",
            size: "996385",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/100.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.gif",
            webp:
              "https://media2.giphy.com/media/UlN4m79dsYXte/100.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100.webp",
            webp_size: "532000",
            width: "100",
          },
          fixed_height: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.mp4",
            mp4_size: "1021696",
            size: "3494775",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.gif",
            webp:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200.webp",
            webp_size: "1797406",
            width: "200",
          },
          downsized_small: {
            height: "150",
            mp4:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy-downsized-small.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-downsized-small.mp4",
            mp4_size: "182490",
            width: "150",
          },
          preview: {
            height: "150",
            mp4:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy-preview.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.mp4",
            mp4_size: "41816",
            width: "150",
          },
          fixed_width_downsampled: {
            height: "200",
            size: "126370",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200w_d.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.gif",
            webp:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200w_d.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_d.webp",
            webp_size: "82354",
            width: "200",
          },
          fixed_width_small_still: {
            height: "100",
            size: "7078",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/100w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w_s.gif",
            width: "100",
          },
          fixed_width_small: {
            height: "100",
            mp4:
              "https://media2.giphy.com/media/UlN4m79dsYXte/100w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.mp4",
            mp4_size: "44893",
            size: "996385",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/100w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.gif",
            webp:
              "https://media2.giphy.com/media/UlN4m79dsYXte/100w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=100w.webp",
            webp_size: "532000",
            width: "100",
          },
          original_still: {
            height: "360",
            size: "108047",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy_s.gif",
            width: "360",
          },
          fixed_width_still: {
            height: "200",
            size: "21758",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200w_s.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w_s.gif",
            width: "200",
          },
          looping: {
            mp4:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy-loop.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-loop.mp4",
            mp4_size: "6271570",
          },
          fixed_width: {
            height: "200",
            mp4:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200w.mp4?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.mp4",
            mp4_size: "1021696",
            size: "3494775",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200w.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.gif",
            webp:
              "https://media2.giphy.com/media/UlN4m79dsYXte/200w.webp?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=200w.webp",
            webp_size: "1797406",
            width: "200",
          },
          preview_gif: {
            height: "70",
            size: "48746",
            url:
              "https://media2.giphy.com/media/UlN4m79dsYXte/giphy-preview.gif?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=giphy-preview.gif",
            width: "70",
          },
          "480w_still": {
            url:
              "https://media3.giphy.com/media/UlN4m79dsYXte/480w_s.jpg?cid=05e839f4c00e13392cb5c0044db8a6fcf991a44a532c923c&rid=480w_s.jpg",
            width: "480",
            height: "480",
          },
        },
        analytics_response_payload:
          "e=Z2lmX2lkPVVsTjRtNzlkc1lYdGUmZXZlbnRfdHlwZT1HSUZfU0VBUkNIJmNpZD0wNWU4MzlmNGMwMGUxMzM5MmNiNWMwMDQ0ZGI4YTZmY2Y5OTFhNDRhNTMyYzkyM2M",
        analytics: {
          onload: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=UlN4m79dsYXte&action_type=SEEN",
          },
          onclick: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=UlN4m79dsYXte&action_type=CLICK",
          },
          onsent: {
            url:
              "https://giphy-analytics.giphy.com/simple_analytics?response_id=c00e13392cb5c0044db8a6fcf991a44a532c923c&event_type=GIF_SEARCH&gif_id=UlN4m79dsYXte&action_type=SENT",
          },
        },
      },
    ],
    pagination: { total_count: 33824, count: 25, offset: 0 },
    meta: {
      status: 200,
      msg: "OK",
      response_id: "c00e13392cb5c0044db8a6fcf991a44a532c923c",
    },
  };
  const { data, pagination } = response;
  return { data, pagination };
}

export { searchForGifs, searchForGifsUrl };

/*
  HELPERS
*/

function objectToParams(object: { [key: string]: any }): string {
  return Object.entries(object)
    .map(([key, value]) => `&${key}=${value}`)
    .join("");
}
